import { tBulkMessageContext } from 'src/pages/Pipe/modals/BulkMessageWABModal/BulkMessage.types.ts';
import {
  eBulkMessageSteps,
  eOptionSelected,
} from 'src/pages/Pipe/modals/BulkMessageWABModal/BulkMessage.enum.ts';

// Meta WhatsApp Business API caps a template's BODY component at 1024 chars
// *after* variable substitution (hydration). A template that looks fine in the
// editor can still exceed this once the user's variable values are plugged in,
// so we enforce the limit at hydration time as well.
export const WHATSAPP_TEMPLATE_BODY_MAX_CHARS = 1024;

export const initialState: tBulkMessageContext = {
  step: eBulkMessageSteps.LEAD_TYPE,
  setStep: () => {},
  number: 0,
  setNumber: () => {},
  bulkMessagesLeads: [],
  setBulkMessagesLeads: () => {},
  loading: false,
  setLoading: () => {},
  handleStepChange: () => {},
  templates: [],
  setTemplates: () => {},
  getTemplates: async () => {},
  loadingTemplates: false,
  setLoadingTemplates: () => {},
  selectedTemplate: null,
  setSelectedTemplate: () => {},
  handleSend: async () => {},
  paramValues: {},
  setParamValues: () => {},
  imageUrl: '',
  setImageUrl: () => {},
  imageFileName: '',
  setImageFileName: () => {},
  setOptionSelected: () => {},
  optionSelected: eOptionSelected.NUMBER,
  getMediaTypeFromUrl: () => 'image',
  variableDefinitions: [],
  hydratedBodyLength: 0,
  isBodyOverLimit: false,
  hasNoRecipients: false,
  recipientPreview: null,
  previewLoading: false,
  previewStale: false,
  creditError: null,
};
